import { render, staticRenderFns } from "./RoleDetailView.vue?vue&type=template&id=42a21f5a&scoped=true&"
import script from "./RoleDetailView.vue?vue&type=script&lang=js&"
export * from "./RoleDetailView.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/all-admin.css?vue&type=style&index=0&id=42a21f5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a21f5a",
  null
  
)

export default component.exports